import toast from 'react-hot-toast';

export function copyToClipboard(value: string, message: string) {
  void navigator.clipboard?.writeText(value);
  toast.success(message);
}
